export const selectConsultationForms = (state) => state?.settings?.consultationForms?.forms ?? [];
export const selectConsultationFormsIsFetching = (state) => state?.settings?.consultationForms?.isFetching ?? false;
export const selectConsultationFormById = (state, formId) => (state?.settings?.consultationForms?.forms ?? []).find((f) => f.id === formId) ?? null;
